/**
 * PT-AUDIT-0228: first focusable element of the staff shell. Visually hidden
 * until it receives keyboard focus, then jumps to the main content region.
 */
export const MAIN_CONTENT_ID = 'main-content';

export function SkipToContentLink() {
  return (
    <a
      href={`#${MAIN_CONTENT_ID}`}
      data-testid="skip-to-content"
      onClick={(event) => {
        const target = document.getElementById(MAIN_CONTENT_ID);
        if (target) {
          event.preventDefault();
          target.focus();
          target.scrollIntoView?.({ block: 'start' });
        }
      }}
      className="sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-[100] focus:rounded-lg focus:bg-white focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-blue-700 focus:shadow-lg focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-blue-600"
    >
      Skip to main content
    </a>
  );
}
